<template>
  <div id="__next">
    <UtilityNav />
    <NavBar v-if="route.meta.showNavBar && !(device ==='mb' && route.name === 'SearchJob')"/>
    <main>
      <router-view v-slot="{ Component }">
        <transition>
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </transition>
      </router-view>
    </main>
    <Footer v-if="route.meta.showFooter || (device ==='pc' && route.name === 'SearchJob')"/>
    <ConfigProvider v-if="device!=='pc' && route.meta.showTabBar" :theme-vars="themeVars">
      <Tabbar :z-index="10" placeholder safe-area-inset-bottom active-color="#000000" inactive-color="#808891"
        v-model="active">
        <TabbarItem class="active-item" v-for="(item, index) in tabList" :key="index" :to="item.path">
          <span>{{ item.title }}</span>
          <template #icon="props">
            <img :src="props.active ? item.activeIcon : item.icon" alt=""/>
          </template>
        </TabbarItem>
      </Tabbar>
    </ConfigProvider>
    <BackTop v-if="device === 'mb'" class="my-back-top" :bottom="124" :right="20">
    </BackTop>
  </div>
</template>
<script setup>
import home from '@/assets/image/tabbar/home.png'
import home_active from '@/assets/image/tabbar/home-active.png'
import lifeHilton from '@/assets/image/tabbar/lifeHilton.png'
import lifeHilton_active from '@/assets/image/tabbar/lifeHilton-active.png'
import benefits from '@/assets/image/tabbar/benefits.png'
import benefits_active from '@/assets/image/tabbar/bennefits-active.png'
import search from '@/assets/image/tabbar/search.png'
import search_active from '@/assets/image/tabbar/search-active.png'
import { provide, computed } from 'vue'
import UtilityNav from './components/UtilityNav.vue'
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'
import useDetectDevice from "@/hooks/useDetectDevice";
import useNavListen from "@/hooks/useNavListen";
import { Tabbar, TabbarItem, ConfigProvider, BackTop } from 'vant';
import { useRoute } from 'vue-router'
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();
const { device } = useDetectDevice()
useNavListen()
provide('device', device)
const route = useRoute()

const themeVars = {
  "-tabbar-height": '72px'
}
const tabList = computed(()=>{
  return [
  {
      title: t('tabList.homepage'),
    icon: home,
    path: '/home',
    activeIcon: home_active
  }, {
      title: t('tabList.lifeAtHilton'), 
      icon: lifeHilton,
      path:  '/lifeAtHilton',
    activeIcon: lifeHilton_active
  }, {
      title: t('tabList.benefits'),
    icon: benefits,
    path: '/benefits',
    activeIcon: benefits_active
  }, {
      title: t('tabList.searchJobs'),
    icon: search,
    path: '/searchJob',
    activeIcon: search_active
  }
]
}
)
const active = computed(() => {
  let index = 0
  const path = route.path
  tabList.value.forEach((item,i)=>{
    if(item.path === path){
      index =i
    }
  })
  return index
})
</script>

<style lang='scss' scoped>

 ::v-deep(.van-tabbar-item--active) {
   background-color: #F0E9E6;
   border-top: 2px solid #C028B9;
 }
 
  :deep(.van-hairline--top-bottom:after) {
        border: 0 solid #ebedf000;
  }
</style>
<style lang="scss">
.my-back-top.van-back-top {
     background-color: #fff;
     color: var(--hc-color--darkblue);
   }
</style>